import React, { useContext, useEffect, useRef, useState } from 'react';
import { Text, Flex, Icon, Tooltip, useDisclosure, Menu, MenuButton, Portal, MenuList, MenuItem, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, Box, IconButton } from '@chakra-ui/react';
import { MdArrowForward, MdArrowOutward, MdArrowRightAlt, MdDevices, MdDragIndicator, MdFace, MdKeyboardArrowRight, MdMoreVert, MdOutlineAccountTree, MdOutlineDelete, MdOutlineRoute } from 'react-icons/md';
import ProductProvider from '@/products/lib/productProvider';
import PersonaProvider from '../../lib/personaProvider';
import ProductLogo from '@/products/components/productLogo';
import PersonaThumbnail from '../../components/personaThumbnail';
import useExperienceApi from '@/experiences/lib/useExperienceApi';
import { PersonaPageContext } from '../lib/personaPageContext';
import MoveExperienceInPersonaToGroupForm from './moveExperienceInPersonaToGroupForm';
import { PersonaContext } from '../../lib/personaContext';
import { Link, useNavigate } from 'react-router-dom';
import InsightTags from '../../../insight/components/insightTags';
import SharedExperienceTag from '../../../components/sharedExperienceTag';
import useTranslation from '../../../lib/i18n/useTranslation';
export default function ExperiencesInPersonaListItem(props) {
  const { t } = useTranslation();
  const {
    refreshExperienceList,
    refreshProductList,
    experienceGroupList,
    group
  } = useContext(PersonaPageContext);
  const {
    data,
  } = props;
  const {
    personaId,
    rights,
  } = useContext(PersonaContext);
  const [isDeleting, setIsDeleting] = useState(false);
  const [productList, setProductList] = useState(false);
  const [personaList, setPersonaList] = useState(false);
  const navigate = useNavigate();
  const modalMoveToGroup = useDisclosure();
  const ref1 = useRef(null);
  const [isAdding, setIsAdding] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const experienceApi = useExperienceApi();
  const leaveTheGroup = async () => {
    try {
  
      await experienceApi.moveExperienceToGroupInPersona(
        personaId,
        data.experience.id,
        group?.group_id
      );
      await Promise.all([
        refreshExperienceList(),
        refreshProductList()
      ])
      navigate(`/persona/${personaId}?group-id=${group?.group_id || ''}`);
    } catch (error) {
      console.error(error);
    }
  }
  const removeExperienceFromPersona = async () => {
    try {
      setIsDeleting(true);
      
      const experiencePersonaId = data?.experience_persona?.id || data?.id;
      
      if (!experiencePersonaId) {
        console.error('❌ Error: No valid ID found for experience removal', data);
        setIsDeleting(false);
        return;
      }
  
      await experienceApi.removeExperienceFromPersona(experiencePersonaId);
      await refreshExperienceList()
      setIsDeleting(false);
    } catch (e) {
      console.error('❌ Error in removeExperienceFromPersona:', e);
      setIsDeleting(false);
    }
  }
  useEffect(() => {
    if (data) {
      if (data.personas && data.personas[0] !== null) {
        setPersonaList(data.personas)
      }
      if (data.products && data.products[0] !== null) {
        setProductList(data.products)
      }
    }
  }, [data]);
  return (
    <>
      <Flex
        px={3}
        py={2}
        backgroundColor="white"
        role={'group'}
        _hover={{
          background: "background.grey",
        }}
        position={"relative"}
        height={"90px"}
      >
        {rights.can_update && (
          <Flex
            position={"absolute"}
            top="0"
            left={"0"}
            height={"100%"}
            opacity={0}
            _groupHover={{ opacity: '1' }}
            cursor={"grab"}
            py={2}
            pr={3}
          >
            <Icon
              as={MdDragIndicator}
              boxSize={'20px'}
              color={"text.light.grey"}
              mr={2}
            />
          </Flex>
        )}
        <Flex
          flexDirection={"column"}
          flex={1}
        >
          <Flex
            alignItems={"flex-start"}
            mb={1}
          >
            <Icon
              as={MdOutlineRoute}
              boxSize={'15px'}
              mr={2}
              mt={"3px"}
            />
            <Flex flexDirection={"column"}>
              <Text noOfLines={2} >{data?.experience?.objective || data?.objective}</Text>
              {(data?.shared_experiences?.name) && (
                <Flex mt={1}>
                  <SharedExperienceTag 
                    sharedExperienceName={data?.shared_experiences?.name} 
                    size="sm"
                  />
                </Flex>
              )}
            </Flex>
          </Flex>
        </Flex>
        <Flex
          flexDirection={"column"}
          alignItems={"flex-end"}
          justifyContent={"space-between"}
          height={"100%"}
        >
          <Flex alignItems={"center"}>
            <Flex flexDirection={"column"} alignItems={"flex-end"}>
              {data.insights_count && (
                <Flex mb={3}>
                  <InsightTags
                    nbPostiveFeedback={data.insights_count.positive_count}
                    nbNegativeFeedback={data.insights_count.negative_count}
                    nbImprovementFeedback={data.insights_count.improvement_count}
                    nbBehavior={data.insights_count.behavior_count}
                    nbMotivation={data.insights_count.motivation_count}
                  />
                </Flex>
              )}
              <Flex alignItems={"center"}>
                <Flex alignItems={"center"} >
                  {(personaList && personaList.length > 0) && (
                    <Flex
                      alignItems={"center"}
                      mr={3}
                    >
                      <Icon
                        as={MdFace}
                        size="20"
                        color="text.medium.grey"
                      />
                      {personaList.map((p, i) => (
                        <Tooltip
                          label={p.name}
                          key={i}
                        >
                          <Link to={`/persona/${p.id}`} onClick={(e) => {
                            e.stopPropagation()
                          }}>
                            <Flex
                              ml={2}
                            >
                              <PersonaProvider
                                personaId={p.id}
                                originalPersona={p}
                                needRights={false}
                                needRole={false}
                                needEditionRequest={false}
                              >
                                <PersonaThumbnail
                                  size={20}
                                  hasAcronym={true}
                                />
                              </PersonaProvider>
                            </Flex>
                          </Link>
                        </Tooltip>
                      ))}
                    </Flex>
                  )}
                </Flex>
                {(productList && productList.length > 0) && (
                  <Flex alignItems={"center"}>
                    <Icon
                      as={MdDevices}
                      size="20"
                      color="text.medium.grey"
                    />
                    {productList && productList.map((p, i) => (
                      <Tooltip
                        label={p.name}
                        key={i}
                      >
                        <Link to={`/products/${p.id}`} onClick={(e) => {
                          e.stopPropagation()
                        }}>
                          <Flex
                            ml={2}
                          >
                            <ProductProvider
                              productId={p.id}
                              orignalProduct={p}
                              needRights={false}
                              needRole={false}
                              needEditionRequest={false}
                            >
                              <ProductLogo
                                size={20}
                                hasAcronym={true}
                              />
                            </ProductProvider>
                          </Flex>
                        </Link>
                      </Tooltip>
                    ))}
                  </Flex>
                )}
              </Flex>
            </Flex>
            <Flex
              ml={3}
              alignItems={"center"}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              {(!rights.can_update) &&
                <IconButton
                  icon={<MdArrowForward />}
                  fontSize={"18px"}
                  size="md"
                  variant='greyTransparent'
                  opacity={"0"}
                  _groupHover={{ opacity: '1' }}
                  onClick={(e) => {
                    navigate(`/experiences/${data.id}`, { replace: true });
                  }}
                />
              }
              {rights.can_update &&
                <Menu >
                  {({ isOpen }) => (
                    <>
                      <MenuButton
                        isActive={isOpen}
                        as={IconButton}
                        icon={<MdMoreVert />}
                        fontSize={"18px"}
                        size="md"
                        variant='greyTransparent'
                      />
                      <Portal>
                        <MenuList zIndex="popover">
                          <MenuItem onClick={(e) => {
                            navigate(`/experiences/${data.id}`, { replace: true });
                          }} >
                            <Icon as={MdArrowForward} mr={2} color="text.medium.dark" />
                            <Text color="text.medium.dark">{t('experience.goToExperience')}</Text>
                          </MenuItem>
                          {((experienceGroupList && experienceGroupList.length > 0) && !data.shared_experiences?.id) &&
                            <MenuItem onClick={modalMoveToGroup.onOpen} >
                              <Icon as={MdArrowOutward} mr={2} color="text.medium.dark" />
                              <Text color="text.medium.dark"> {t('group.moveToGroup')}</Text>
                            </MenuItem>
                          }
                          {(data?.experience_persona?.persona_experience_group_id || data?.persona_experience_group_id) &&
                            <MenuItem
                              onClick={leaveTheGroup}
                            >
                              <Icon as={MdArrowOutward} mr={2} color="text.medium.dark" />
                              <Text color="text.medium.dark">{t('experience.leaveGroup')}</Text>
                            </MenuItem>
                          }
                          {!data.shared_experiences?.id && (
                            <MenuItem
                              onClick={removeExperienceFromPersona}
                              color={"text.medium.red"}
                            >
                              <Icon as={MdOutlineDelete} mr={2} color="text.medium.red" />
                              <Text color="text.medium.red">{t('persona.removeFromPersona')}</Text>
                            </MenuItem>
                          )}
                        </MenuList>
                      </Portal>
                    </>
                  )}
                </Menu>
              }
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      <Modal isOpen={modalMoveToGroup.isOpen} onClose={modalMoveToGroup.onClose}>
        <ModalOverlay />
        <ModalContent >
          <ModalHeader>{t('group.moveToGroup')}</ModalHeader>
          <ModalBody >
            <Box p={3}>
              <MoveExperienceInPersonaToGroupForm
                personaId={personaId}
                experienceId={data?.experience?.id}
                hideSave={true}
                onValidityChange={setIsValid}
                onSubmitting={() => {
                  setIsAdding(true);
                }}
                onSubmitted={() => {
                  setIsAdding(false);
                  Promise.all([
                    refreshExperienceList(),
                    refreshProductList()
                  ])
                  modalMoveToGroup.onClose();
                }}
                ref={ref1}
              />
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="blueOutline"
              onClick={modalMoveToGroup.onClose}
            >{t('common.cancel')}</Button>
            <Button
              variant="blueFill"
              ml={2}
              isLoading={isAdding}
              isDisabled={!isValid}
              onClick={() => {
                ref1.current.click();
              }}>{t('common.save')}</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
